var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"vf-form-message vf-form-invalid"},[_c('p',[_c('strong',[_vm._v(" Sorry, your form cannot be submitted just yet. One or more required fields have not been completed. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }